<template>
  <!-- Activity log panel next to the sidebar, opened the same way as the notifications panel (US 9372) -->
  <div class="np-wrap">
    <div class="np-backdrop" @click="$emit('close')"></div>
    <aside class="np np--activity"
           role="dialog"
           :aria-label="$t('top_nav.activity_log')"
           @keydown.esc="$emit('close')"
    >
      <div class="np__head">
        <h3 class="np__title">{{ $t('top_nav.activity_log') }}</h3>
        <button type="button"
                class="np__close"
                ref="close"
                @click="$emit('close')"
                :aria-label="$t('app_nav.close')"
        >
          <font-awesome-icon icon="times"/>
        </button>
      </div>
      <div class="np__body np__body--activity">
        <ActivityFeed compact area-filter person-filter/>
      </div>
    </aside>
  </div>
</template>

<script>
import ActivityFeed from '@/components/activity/feed/ActivityFeed.vue';

export default {
  name: 'ActivityPanel',
  components: {
    ActivityFeed
  },
  mounted() {
    this.$refs.close.focus();
  }
}
</script>
